//imports
import React from 'react';
import PropTypes from 'prop-types';
import AboutUs from 'components/LandingPageAboutUs';
import ClientSlider from 'components/LandingPageCarousels/ClientSlider';
import LandingPageHeroTwo from 'components/LandingPageHeroTwo';
import LandingPageLayout from 'components/LandingPageLayout';
import WhyUs from 'components/LandingPageWhyUs';
import TitleSectionThree from 'components/LandingPageTitleSection/TitleSectionThree';
import TitleSectionOne from 'components/LandingPageTitleSection/TitleSectionOne';
import Blogs from 'components/LandingPageBlogs';
import Head from 'next/head';
import { withTranslation } from 'utils/with-i18next';
import FindProperty from 'components/landingPageFindProperty';
import FeaturedLocations from 'components/landingPageFeaturedLocations';


export class IndexPage extends React.PureComponent {
  componentDidMount() {}

  render() {
    const clientsData = [
      {
        id: 1,
        image: 'pivot.png',
        name: 'client-1',
      },
      {
        id: 2,
        image: 'rental.png',
        name: 'client2',
      },
      {
        id: 3,
        image: 'globe.png',
        name: 'client-3',
      },
      {
        id: 4,
        image: 'nationalposts.png',
        name: 'client-4',
      },
      {
        id: 5,
        image: 'toronto.png',
        name: 'client-5',
      },
      {
        id: 6,
        image: 'rental.png',
        name: 'client-6',
      },
    ];
    return (
      <>
        <Head>
          <meta charset="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
           

          <title>Better Renting for landlords and Renters</title>
          <meta
            name="description"
            content="SoulRooms enables landlords to rent efficiently
             to modern renters. For renters, it's the platform to 
             find the housing they want, without much hassle.  "
          />
          <meta name="author" content="SoulRooms" />
          <meta property="og:site_name" content="SoulRooms" />
          <meta property="og:title" content="Better Renting for landlords and Renters" />
          <meta
            property="og:description"
            content="SoulRooms enables landlords
             to rent efficiently to modern renters.
              For renters, it's the platform to 
              find the housing they want,
               without much hassle. "
          />

          <meta property="og:type" content="website" />
          <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
          <meta property="og:locale" content="en_US" />
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:site" content="@soulroomsTO" />
          <meta name="twitter:title" content="SoulRooms" />
          <meta
            name="twitter:description"
            content="SoulRooms enables landlords to rent efficiently
             to modern renters. For renters, it's the platform to 
             find the housing they want, without much hassle. "
          />
          <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
          <meta name="twitter:image:alt" content="SoulRooms" />
          <meta name="theme-color" content="#FCBD00" />
        </Head>

        <LandingPageLayout>
          {/* HERO SECTION  */}
          <LandingPageHeroTwo />
          {/* CLIENT SLIDER  */}
          <ClientSlider
            headingTitle={
              <div className="text-center pt-4 mt-md-3">
                <h1 className="fs-24-30 fw-400 mt-6 mb-2" style={{ color: '#1b1b1b',fontFamily:'Josefin Sansz' }}>
                  Featured in:
                </h1>
              </div>
            }
            heading={true}
            classN="clients-brand-carousel"
            clientsData={clientsData}
            icons={true}
          />
          {/* FIND PROPERTY  */}
          <div className="pt-3 pb-4 md:pb-0">
            <FindProperty
              spacing={true}
              img={
                <img
                  
                  loading="lazy"
                  src="/static/images/landingPages/HomePage/findproperty.png"
                  width="100%"
                  alt="pic"
                  className="h-auto"
                />
              }
              title={'FIND GREAT PROPERTIES BY AMAZING LANDLORDS'}
              href="/find-a-soulroom"
              description={
                <p
                  className="lh-base fs-4 responsiveText pt-lg-3 mt-lg-1 mt-md-1 pt-3  text-2xl mt-1 mb-4 pt-4   "
                  style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
                  Search, identify, and book individual rooms or entire properties for rent.{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Whether you’re moving with friends or flying solo, we’ve got you covered.
                  </span>
                </p>
              }
              tagLine="SoulRooms is where you can"
              btnTitle={'Find a SoulRoom'}
            />
          </div>

          {/*  HOW IT WORKS*/}
          <WhyUs
            title="HOW IT WORKS"
            heading1="Discover Properties"
            detail1="Find properties or rooms 
            that suit your style and budget."
            heading2="Review Listings"
            detail2="Check out photos, floorplans,
             and virtual tours to decide on your perfect rental. "
            heading3="Book & Move"
            detail3="Our online booking platform
             and automated approval process makes
             it easy for landlords and tenants
             to close the deal. "
            img1="/static/images/landingPages/HomePage/howitworks1.png"
            img2="/static/images/landingPages/HomePage/howitworks2.png"
            img3="/static/images/landingPages/HomePage/howitworks3.png"
          />
          {/* TITLE SECTION  */}
          <TitleSectionThree bg={true} title="GET STARTED" btnTxt="Find a SoulRoom" href="/find-a-soulroom" />
          {/* FEATURED LOCATION  */}
          <FeaturedLocations
            title="FEATURED LOCATIONS:"
            card1hd="The Junction, Toronto, Ontario"
            card1txt="Nestled among an intimate community 
            of brand new townhouses, surrounded by several
            art galleries, cafés, restaurants,
            bars, and local shops."
            card1btn="Explore"
            card2hd="Pembina Avenue, Winnipeg, Manitoba"
            card2txt="Minutes away from the entrance
              to The University of Manitoba. A brand
              new building with state-of-the-art
              facilities that are bound to entertain
              students and professionals alike. "
            card2btn="Explore"
            mainImg="/static/images/landingPages/yorksrhubimg.png"
            card1Img="/static/images/landingPages/HomePage/toronto.png"
            card2Img="/static/images/landingPages/HomePage/wini.png"
            href2="/the-junction"
            href3="/winnipeg-soulrooms"
          />
          <FeaturedLocations
            card1hd="Cabbage Town, Old Toronto, Ontario"
            card1txt="Walking distance from
             Ryerson University, and the
              University of Toronto. This 
              neighborhood nests a very strong
               sense of community and was the 
               house of Irish immigrants from the 1840s!"
            card1btn="Explore"
            card2hd="Liberty Village, Toronto, Ontario"
            card2txt="There is a gritty, urban feel and
             a unique vibrancy to Liberty Village, 
             which emanates from the red brick Victorian
              industrial architecture that dominates
               the streetscape."
            card2btn="Explore"
            mainImg="/static/images/landingPages/yorksrhubimg.png"
            card1Img="/static/images/landingPages/HomePage/torontotown.png"
            card2Img="/static/images/landingPages/HomePage/libertyvlg.png"
            href2="/cabbagetown"
            href3="/liberty-village"
          />

          {/*  WHY CHOOSE SOULROOMS SECTION  */}
          <WhyUs
            title="WHY CHOOSE SOULROOMS?"
            heading1="Current Toronto real estate"
            detail1="For a single individual, all
             the market has to offer is condos 
             starting at $1950/month, with  
             inconvenient processes and tons of hassle"
            heading2="The alternative"
            detail2="Can you really trust a stranger looking 
          for a roommate on the internet?"
            heading3="Great Lifestyle"
            detail3="Love where you live and who
             you live with. Toronto's most innovative
              renting platform, designed by digital
               natives for digital natives. "
            img1="/static/images/landingPages/whychoosecircle1.png"
            img2="/static/images/landingPages/whychoosecircle2.png"
            img3="/static/images/landingPages/whychoosecircle3.png"
          />
          <TitleSectionOne
            title="MAKE ROOM FOR SAVINGS WITH SOULROOMS!"
            btnTxt="Check out Properties"
            bg="black"
            hrefExt="https://www.realsage.com/properties"
          />

          {/* ABOUT US  */}
          <AboutUs />

          {/*old component BLOG SECTION  */}
          <Blogs bg="/static/images/landingPages/blogsbg.png" />

          {/* BLOGSECTION */}

          {/* <BlogsV1 head1={"READ: SUGAR, SPICE AND ALL THINGS NICE…"}/> */}
        </LandingPageLayout>
      </>
    );
  }
}

IndexPage.propTypes = {
  t: PropTypes.func,
};

IndexPage.getInitialProps = async () => ({
  namespacesRequired: ['common', 'banner', 'features'],
});

export default withTranslation('common')(IndexPage);
